module.exports = __webpack_public_path__ + "svg/fullscreen-close.svg?81edb7e007bb9786465f4ad2131be82e";